/**
 * AuthGate - garde pour les routes protegees.
 *
 * SECURE BY DEFAULT : auth requise sauf si VITE_REQUIRE_AUTH est explicitement
 * 'false' (mode demo dev local). Avant juin 2026 on avait l inverse - si l env
 * var n etait pas setteee, mode demo passait silencieusement en prod et tout
 * le monde acccedait au Dashboard sans login. Bug repere apres la regression
 * du SWA backend linking.
 *
 *  VITE_REQUIRE_AUTH=true   -> auth requise (par defaut si absent)
 *  VITE_REQUIRE_AUTH=false  -> mode demo, laisse passer (dev local sans API)
 *
 * NOTE : ce composant ne wrappe PAS les routes /login et /auth/verify
 * (qui doivent rester accessibles aux anonymes). Le routing est gere
 * cote App.tsx.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@fluentui/react-components';
import { useAuth } from './AuthContext';

// Auth requise sauf opt-out explicite. Pas defini = comportement secure.
const requireAuth = import.meta.env.VITE_REQUIRE_AUTH !== 'false';

export function AuthGate({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Mode demo / dev local : laisse passer
  if (!requireAuth) {
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div style={{
        height: '100vh', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <Spinner label="Verification de votre session..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
